export const ROUTES = {
  CONFIGURATION_TRANSLATION_DETAILS: "/configuration/translations/details",
};
